import React, { useEffect, useState } from 'react';
import {
  RiChat4Line,
  RiChatOffLine,
  RiVolumeUpLine,
  RiVolumeMuteLine
} from 'react-icons/ri';
import {
  NotificationShowWrapper,
  ToggleShowWrapper,
  IconWrapper
} from './styled';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import { useSelector } from 'react-redux';

function FlexNotificationFormAlert({
  isOpen,
  changeRangeAudioNotificationVolume
}) {
  const { primary_color } = useSelector((state) => state.systemConfiguration);
  const [isVolumeEnabled, setIsVolumeEnabled] = useState(false);
  const [isNotificationsEnabled, setIsNotificationsEnabled] = useState(false);

  const defaultVolume =
    localStorage.getItem('@flexuc/audioNotificationVolume') || '0.5';

  const audioEnabled = localStorage.getItem('@flexuc/audioEnabled');
  const isNotificationsChatEnabled = localStorage.getItem(
    '@flexuc/isNotificationsChatEnabled'
  );

  useEffect(() => {
    setIsVolumeEnabled(JSON.parse(audioEnabled));
    setIsNotificationsEnabled(JSON.parse(isNotificationsChatEnabled));
  }, [audioEnabled, isNotificationsChatEnabled]);

  const handleVolumeToggle = () => {
    setIsVolumeEnabled(!isVolumeEnabled);
    localStorage.setItem('@flexuc/audioEnabled', !isVolumeEnabled);
  };

  const handleNotificationsToggle = () => {
    setIsNotificationsEnabled(!isNotificationsEnabled);
    localStorage.setItem(
      '@flexuc/isNotificationsChatEnabled',
      !isNotificationsEnabled
    );
  };

  if (!isOpen) return null;

  return (
    <NotificationShowWrapper className="flexNotificationForm">
      <ToggleShowWrapper>
        <IconWrapper>
          {isNotificationsEnabled ? (
            <RiChat4Line
              onClick={handleNotificationsToggle}
              size={26}
              color={primary_color}
              title="Desativar notificações de pop-up"
            />
          ) : (
            <RiChatOffLine
              onClick={handleNotificationsToggle}
              size={26}
              color={primary_color}
              title="Ativar notificações de pop-up"
            />
          )}
        </IconWrapper>
        <IconWrapper>
          {isVolumeEnabled ? (
            <RiVolumeUpLine
              onClick={handleVolumeToggle}
              size={26}
              color={primary_color}
              title="Desativar notificações sonoras"
            />
          ) : (
            <RiVolumeMuteLine
              onClick={handleVolumeToggle}
              size={26}
              color={primary_color}
              title="Ativar notificações sonoras"
            />
          )}
        </IconWrapper>
      </ToggleShowWrapper>

      {isVolumeEnabled && (
        <input
          type="range"
          orient="horizontal"
          className="volumeBar"
          max="1"
          onChange={changeRangeAudioNotificationVolume}
          step="0.1"
          defaultValue={defaultVolume}
        />
      )}
    </NotificationShowWrapper>
  );
}

export default FlexNotificationFormAlert;
